import { defineStore, acceptHMRUpdate } from 'pinia'
import { tnApi } from '@/api'

export const useDashboardStore = defineStore('dashboard_store', {
  state: () => ({
    stats: [],
    inquiryStats: {},
    isLoading: false
  }),
  actions: {
    async loadStats () {
      this.isLoading = true
      const { dashboardStats } = tnApi(true)
      try {
        const { stats, inquiryStats } = await dashboardStats()
        this.inquiryStats = inquiryStats
        this.stats = stats
        this.isLoading = false
      } catch (error) {
        return Promise.reject(error)
      }
    },
    resetStats () {
      this.stats = []
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDashboardStore, import.meta.hot))
}
